// extracted by mini-css-extract-plugin
export default {"padding":"BookYourGuide_padding__OlkVK"};